import * as VueGoogleMaps from '@/components/Maps/main.js'
import Vue from 'vue'
Vue.use(VueGoogleMaps)